import React, {useEffect, useState} from "react";
import Auxiliary from "../../../hoc/Auxiliary";
import HeaderBreadCrumb, {normalizePathItem} from "../../../components/BreadCrumb/Breadcrumb";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {
    batchExecutePythonScript,
    batchExecuteSparqlQueries,
    retrieveSparqlQueries
} from "../../../api/dataCollection/sparql-queries-service";

import {Card} from "primereact/card";
import LoadingScreen from "../../LoadingScreen/LoadingScreen";
import QueryConfiguration
    from "../../../components/StudyTeams/DataCollectionList/ActionTemplate/QueryConfiguration/QueryConfiguration";
import {findDataCollectionById} from "../../../api/dataCollection/dataCollection-service";
import {loadState, removeFromSessionStorage} from "../../../api/State/manage-state-storage-service";
import {showError} from "../../../api/notification/ToastManager";
import {STUDY_TEAM_SPACE_PATH} from "../../../api/static-data/Configurations";
import {InputText} from "primereact/inputtext";

import {TabPanel, TabView} from 'primereact/tabview';
import "./DataCollectionQueriesForStudyTeamsStyle.css"
import {Button} from "primereact/button";
import {isAuthorized} from "../../../api/authorization/authorization-service";
import {Checkbox} from "primereact/checkbox";

const DataCollectionQueriesForStudyTeams = () => {
    const [crumbs, setCrumbs] = useState([]);
    const [queries, setQueries] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [dcMarketNodes, setDcMarketNodes] = useState([]);
    const {state} = useLocation();
    const dataCollection = loadState(state, "dataCollection");
    const urlParams = useParams();
    const navigate = useNavigate();
    const [filter, setFilter] = useState("");
    const [activeTab, setActiveTab] = useState(0)
    const [isSelectAllSparqlChecked, setIsSelectAllSparqlChecked] = useState(false);
    const [isSelectAllPythonChecked, setIsSelectAllPythonChecked] = useState(false);

    const fetchQueries = async (dcId) => {
        let data = [];
        await retrieveSparqlQueries(dcId)
            .then(res => {
                if (res.status === 200) {
                    data = res.content;
                } else {
                    navigate(STUDY_TEAM_SPACE_PATH);
                }
            })
        return data;
    }
    const findMarketNodesByDC = (dcId) => {

        findDataCollectionById(dcId).then(r => {
            let m = []
            r.participants.forEach(x => {
                m.push(x.marketNode)
            });

            let marketNodes = m.filter((ele, ind) => ind === m.findIndex(elem => elem.name === ele.name))
            setDcMarketNodes(marketNodes)
        })
    }

    const loadQueriesPage = () => {
        try {
            if (urlParams?.dcName && urlParams.dcName.toLowerCase() === normalizePathItem(dataCollection?.name)) {
                setCrumbs(["Study team space", dataCollection?.name, "Queries"])
                fetchQueries(dataCollection?.id).then(res => {
                    setQueries(prev =>
                        res.map(q => {
                            const old = prev.find(p => p.queryId === q.queryId);
                            return {
                                ...q,
                                isChecked: old ? old.isChecked : false
                            };
                        })
                    );
                    findMarketNodesByDC(dataCollection?.id);
                    setIsLoading(false);

                }).catch(_ => {
                    onResponseError("Failed to retrieve queries for dataCollection " + dataCollection?.name)
                });
            } else {
                onResponseError("Access to dataCollection queries details from address bar is not authorized")
            }
        } catch (e) {
            onResponseError("An error occurs while displaying 'Queries' page for dataCollection " + dataCollection?.name)
        }
    }

    useEffect(() => {
        loadQueriesPage();
    }, [])

    const onResponseError = (message) => {
        showError("Error loading page", message)
        removeFromSessionStorage("dataCollection");
        navigate(STUDY_TEAM_SPACE_PATH);
    }
    const updateCheck = (queryId, newValue) => {
        setQueries(prev =>
            prev.map(q =>
                q.queryId === queryId ? {...q, isChecked: newValue} : q
            )
        );
    };
    useEffect(() => {
        const status = queries
            .map(q => q["executions"])
            .flat()
            .map(ex => ex.status.code);
        if (status.includes('EXECUTION_IN_PROGRESS')) {
            setTimeout(() => {
                updateQueries();
            }, 30000)
        }
    }, [queries])

    const filteredQueries = queries.filter((query) =>
        query.name.toLowerCase().includes(filter.toLowerCase())
    );
    const updateQueries = () => {
        fetchQueries(dataCollection?.id).then(res => {
            setQueries(prev =>
                res.map(q => {
                    const old = prev.find(p => p.queryId === q.queryId);
                    return {
                        ...q,
                        isChecked: old ? old.isChecked : false
                    };
                })
            );
        });
    }

    const runSparqlQueries = () => {
        const content = {
            queriesIds: queries.filter(q => q.isChecked === true).map(x => x.queryId),
            dcId: dataCollection.id
        };

        const promise = batchExecuteSparqlQueries(content);
        setTimeout(() => loadQueriesPage(), 1000)
        promise
            .then(() => {
                loadQueriesPage();
                fetchQueries(dataCollection?.id).then(res => {
                    res.forEach(r => {
                        r['isChecked'] = false;
                    })
                    setQueries(res);
                })
            })
            .catch((err) => {
                showError("Execution error", "Failed to execute SPARQL queries");
            })

    };
    const runPythonScripts = () => {

        const content = {
            scriptsIds: queries.filter(q => q.isChecked === true).map(x => x.queryId),
            dcName: dataCollection.name
        };
        const promise = batchExecutePythonScript(content);
        setTimeout(() => loadQueriesPage(), 1000)

        promise
            .then(() => {
                loadQueriesPage();
                fetchQueries(dataCollection?.id).then(res => {
                    res.forEach(r => {
                        r['isChecked'] = false;
                    })
                    setQueries(res);
                })
            })
            .catch((err) => {
                showError("Execution error", "Failed to execute Python scripts");
            })

    };
    const sparqlQueries = filteredQueries.filter(q => q.queryType === "SparQLQuery");
    const hasSparqlQueries = sparqlQueries.length > 0;
    const sparqlAll = queries.filter(q => q.queryType === "SparQLQuery");
    const hasChecked = sparqlAll.some(q => q.isChecked);
    const hasRunning = sparqlAll.some(q =>
        q.executions?.some(e => e.status.code === "EXECUTION_IN_PROGRESS")
    );
    const canExecuteSparql = isAuthorized("AR031") && hasSparqlQueries;
    const pythonQueries = filteredQueries.filter(q => q.queryType === "PythonScript");
    const hasPythonQueries = pythonQueries.length > 0;
    const pythonAll = queries.filter(q => q.queryType === "PythonScript");
    const hasPythonChecked = pythonAll.some(q => q.isChecked);
    const hasPythonRunning = pythonAll.some(q =>
        q.executions?.some(e => e.status.code === "EXECUTION_IN_PROGRESS")
    );

    const canExecutePython = isAuthorized("AR031") && hasPythonQueries;
    const content = isLoading ? (
            <LoadingScreen/>
        ) : (
            <Auxiliary>
                <HeaderBreadCrumb items={crumbs}/>
                <br/>
                <TabView activeIndex={activeTab} onTabChange={(e) => {
                    setFilter("");
                    setActiveTab(e.index)
                }}>
                    <TabPanel header="SparQL Queries" className={"custom-tab-panel"}>
                        <div className="mb-3 flex items-center gap-2">
                            <InputText
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                placeholder="Filter queries..."
                            />

                            <div className="ml-auto flex align-items-center">

                                <Checkbox style={{marginRight: "10px"}}
                                          checked={isSelectAllSparqlChecked}
                                          onChange={(e) => {
                                              const value = e.checked;
                                              setIsSelectAllSparqlChecked(value);
                                              setQueries(prev =>
                                                  prev.map(q =>
                                                      q.queryType === "SparQLQuery"
                                                          ? {...q, isChecked: value}
                                                          : q
                                                  )
                                              );
                                          }}
                                />
                                { canExecuteSparql &&   <label style={{paddingRight: "40px", fontWeight: "600"}}>Select All</label>}
                                {canExecuteSparql && (
                                    <Button
                                        disabled={!hasChecked || hasRunning}
                                        label={hasRunning ? "Executing queries..." : "Execute queries"}
                                        className="btn executionButton"
                                        onClick={runSparqlQueries}
                                        loading={hasRunning}
                                    />
                                )}
                            </div>
                        </div>
                        {filteredQueries.length > 0 ? (
                            filteredQueries.filter(querie => querie.queryType === "SparQLQuery").map((e, i) => (
                                <div className="mb-3" key={`cat-${i + 1}`}>
                                    <QueryConfiguration
                                        loadQueriesPage={loadQueriesPage}
                                        dcMarketNodes={dcMarketNodes}
                                        query={e}
                                        updateCheck={updateCheck}
                                        updateQueries={updateQueries}
                                        dc={dataCollection}
                                    />
                                </div>
                            ))
                        ) : (
                            <Card role="region">No query is defined !</Card>
                        )}
                    </TabPanel>
                    <TabPanel header="Python Scripts" className={"custom-tab-panel"}>
                        <div className="mb-3 flex items-center gap-2">
                            <InputText
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                placeholder="Filter queries..."
                            />

                            <div className="ml-auto flex align-items-center">

                                <Checkbox style={{marginRight: "10px"}}
                                          checked={isSelectAllPythonChecked}
                                          onChange={(e) => {
                                              const value = e.checked;
                                              setIsSelectAllPythonChecked(value);
                                              setQueries(prev =>
                                                  prev.map(q =>
                                                      q.queryType === "PythonScript"
                                                          ? {...q, isChecked: value}
                                                          : q
                                                  )
                                              );
                                          }}
                                />
                                { canExecutePython &&  <label style={{paddingRight: "40px", fontWeight: "600"}}>Select All</label>}

                                {canExecutePython && (
                                    <Button
                                        disabled={!hasPythonChecked || hasPythonRunning}
                                        label={hasPythonRunning ? "Executing queries..." : "Execute queries"}
                                        className="btn executionButton"
                                        onClick={runPythonScripts}
                                        loading={hasPythonRunning}
                                    />
                                )}

                            </div>
                        </div>
                        {filteredQueries.length > 0 ? (
                            filteredQueries.filter(querie => querie.queryType === "PythonScript").map((e, i) => (
                                <div className="mb-3" key={`cat-${i + 1}`}>
                                    <QueryConfiguration
                                        loadQueriesPage={loadQueriesPage}
                                        dcMarketNodes={dcMarketNodes}
                                        query={e}
                                        updateCheck={updateCheck}
                                        updateQueries={updateQueries}
                                        dc={dataCollection}
                                    />
                                </div>
                            ))
                        ) : (
                            <Card role="region">No python script is defined !</Card>
                        )}
                    </TabPanel>
                </TabView>
            </Auxiliary>
        )
    ;

    return <Auxiliary>{content}</Auxiliary>;
}
export default DataCollectionQueriesForStudyTeams;
